module.exports = __webpack_public_path__ + "img/onboarding-step2.5ea9f768329eb5aa0dc0.2c823ce0.png";